document.addEventListener("DOMContentLoaded", function () {
  const template = document.querySelector(".shopify-section-sticky");
  const extraAddToCart = document.querySelector(".product__info-container .product-form")
  document.addEventListener('button:render', (event) => {
    if (!template) return;
    const idTemplate = document.querySelector(".product-sticky__button").id;
    const detail = event?.detail;
    if (!detail || !idTemplate) return;
    const fullLink = `${detail.url}?variant=${detail.variant}&section_id=${idTemplate}`;
    changeStateSection(template, extraAddToCart).start();
    fetch(fullLink)
      .then(response => {
        return response.text()
      }).then(response => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const stickyItemDestination = document.getElementById(`${idTemplate}`);
        const stickyItemCourse = html.getElementById(`${idTemplate}`);
        if (stickyItemCourse && stickyItemDestination) {
          stickyItemDestination.replaceWith(stickyItemCourse);
        }
      }).catch((error) => {
        changeStateSection(template, extraAddToCart).error();
        console.log(error);
      }).finally(() => {
        changeStateSection(template, extraAddToCart).finish();
      })
  });

  function changeStateSection(htmlElement, extraButton) {
    return {
      start() {
        htmlElement?.classList.add("disabled-section");
      },
      error() {
        htmlElement?.classList.add("hide-section");
        extraButton?.classList.add("show-button")
      },
      finish() {
        htmlElement?.classList.remove("disabled-section");
      }
    }
  }
})


